import { chalkText } from '../../primitives/chalk';

export async function prepareEquationNode(env, spec) {
  const area = env.boardArea();
  const titleSize = env.getStyle('bodySize');
  const equationSize = env.getStyle('codeSize');
  const lineGap = env.getStyle('lineHeight');

  const equations = Array.isArray(spec.equations)
    ? spec.equations.map((eq) => String(eq))
    : [String(spec.equation || '')];

  return {
    area,
    title: spec.title ? String(spec.title) : '',
    equations,
    titleSize,
    equationSize,
    lineGap,
    secPerLine: spec.timing?.secPerLine || 0.8,
    charsPerSec: spec.timing?.charsPerSec || 36,
  };
}

export function commitEquationNode(packet, ctxs, anim) {
  let t = 0;

  anim.add((dt) => {
    t += dt;
    ctxs.ink.clearRect(packet.area.x - 2, packet.area.y - 2, packet.area.w + 4, packet.area.h + 4);

    let y = packet.area.y + packet.titleSize + 8;
    if (packet.title) {
      chalkText(
        ctxs.ink,
        packet.title,
        packet.area.x + packet.area.w / 2,
        y,
        packet.titleSize,
        0.9,
        'ui-sans-serif, system-ui',
        'center'
      );
      y += packet.lineGap;
    }

    const totalLines = packet.equations.length;
    let drawnLines = 0;

    for (let i = 0; i < totalLines; i++) {
      const lineStart = i * packet.secPerLine;
      const localT = t - lineStart;
      if (localT <= 0) continue;

      const eq = packet.equations[i];
      const chars = Math.min(eq.length, Math.floor(localT * packet.charsPerSec));
      const shown = eq.slice(0, chars);
      const lineY = y + i * packet.lineGap;
      chalkText(
        ctxs.ink,
        shown,
        packet.area.x + packet.area.w * 0.06,
        lineY,
        packet.equationSize,
        0.92,
        'ui-monospace, SFMono-Regular, Menlo, monospace',
        'left'
      );

      if (chars >= eq.length) {
        drawnLines++;
      }
    }

    return drawnLines < totalLines;
  });
}
